import config from '../config';

export default function scaleSize(size, round = true) {
  const newSize = size * config.scale;

  return round ? Math.round(newSize) : newSize;
}
